import { z } from 'zod';

import { TEMPLATES_SORT_DESC } from './consts';

/** Search params of the Reply templates route. */
export const replyTemplatesSearchSchema = z.object({
  /** `desc` sorts the templates Z to A; absent, or any other value, means A to Z. */
  templatesSort: z.literal(TEMPLATES_SORT_DESC).optional().catch(undefined)
});

/** Search params of the Reply templates route, as the route reads them. */
export type ReplyTemplatesSearch = z.infer<typeof replyTemplatesSearchSchema>;
